import { createStyles, makeStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

export const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      '& .MuiButton-label': {
        justifyContent: 'flex-end',
      },
      '& svg': {
        stroke: variables.colorV2.dropdown.icon.stroke.default,
      },
      '&:hover, &[data-opened="true"]': {
        backgroundColor: variables.colorV2.dropdown.button.background.hover,
        borderColor: variables.colorV2.dropdown.button.border.hover,
        color: variables.colorV2.dropdown.button.text.hover,
        '& svg': {
          stroke: variables.colorV2.dropdown.icon.stroke.hover,
        },
      },
      '&.MuiButton-containedSecondary': {
        '& svg': {
          stroke: variables.color.primary.white,
        },
        '&:hover, &[data-opened="true"]': {
          backgroundColor: variables.color.secondary.blue,
        },
      },
    },
    buttonTitle: {
      width: '100%',
      display: 'inline-block',
      marginRight: theme.spacing(1.3),
      boxSizing: 'border-box',
    },
    paper: {
      marginTop: variables.gap.xs,
    },
    menuList: {
      minWidth: '17.8rem',
      paddingTop: '0.2rem',
      paddingBottom: variables.gap.sm,
    },
    menuItem: {
      paddingLeft: variables.gap.lg,
      paddingRight: variables.gap.lg,
      paddingTop: '0.6rem',
      paddingBottom: '0.6rem',
      minHeight: 'auto',
      '&:hover': {
        backgroundColor: variables.colorV2.dropdown.list.background.hover,
        '& .MuiTypography-root': {
          color: variables.colorV2.dropdown.list.text.hover,
        },
      },
    },
    menuItemLabel: {
      borderBottom: '0.15rem solid transparent',
    },
  }),
);
